// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3bj2FQkkx{align-items:flex-start}._1Mvwwkvjx{background-color:var(--error-bg)}._2bWPVCPux{background-color:var(--warning-bg)}._4jarlexqx{background-color:var(--info-bg)}._7J0QxRebx{background-color:white}._1UUDz3e6x{background-color:rgba(207,239,167,0.4)}._5ZTJ7BGQx{align-items:flex-start;flex:0 1 100%}._2fZvQ13zx{flex:0 0 auto;margin:-4px -4px -4px 16px}._5JzGtHg5x{margin-left:8px;color:var(--primary-text);font-size:14px;line-height:20px}._3DrjsCLlx{flex-grow:1}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"page-notification": "_3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"pageNotification": "_3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"error": "_1Mvwwkvjx _3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"warning": "_2bWPVCPux _3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"info": "_4jarlexqx _3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"infowhite": "_7J0QxRebx _3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"success": "_1UUDz3e6x _3bj2FQkkx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-l"] + "",
	"content": "_5ZTJ7BGQx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"buttonContainer": "_2fZvQ13zx",
	"text": "_5JzGtHg5x",
	"full-width-text": "_3DrjsCLlx",
	"fullWidthText": "_3DrjsCLlx"
};
module.exports = exports;
